import { SidebarContent, SidebarFooter } from '@myosh/odin-components';
import { useState } from 'react';
import { DateRangeFilter } from '@/components/filters/date-range-filter';
import { FilterActions } from '@/components/filters/filter-actions';
import { HierarchyFilter } from '@/components/filters/hierarchy-filter';
import { ModuleFilter } from '@/components/filters/module-filter';
import { useAppliedFilters } from '@/hooks/use-applied-filters';
import { useScheduleMode } from '@/hooks/use-schedule-mode';
import { validateDateRange } from '@/utils/date-ranges';
import { DEFAULT_FILTER_SELECTION, isSameSelection, resolveSelectionDates } from '@/utils/filter-selection';

// Edits stay in a draft until Apply; Reset applies the defaults straight away.
export const FilterSidebar = () => {
  const { applied, apply } = useAppliedFilters();
  const [mode] = useScheduleMode();
  const [draft, setDraft] = useState(applied);

  const draftDates = resolveSelectionDates(draft, mode, new Date());
  const dateError = validateDateRange(draftDates);
  const canApply = !isSameSelection(draft, applied) && dateError === undefined;

  const handleReset = () => {
    setDraft(DEFAULT_FILTER_SELECTION);
    apply(DEFAULT_FILTER_SELECTION);
  };

  return (
    <>
      <SidebarContent>
        <DateRangeFilter
          range={draft.range}
          dates={draftDates}
          error={dateError}
          onChange={(dateSelection) => setDraft((current) => ({ ...current, ...dateSelection }))}
        />
        <ModuleFilter
          selectedFormIds={draft.forms}
          onChange={(forms) => setDraft((current) => ({ ...current, forms }))}
        />
        <HierarchyFilter
          selectedValueIds={draft.hierarchy}
          onChange={(hierarchy) => setDraft((current) => ({ ...current, hierarchy }))}
        />
      </SidebarContent>
      <SidebarFooter className="border-t">
        <FilterActions canApply={canApply} onReset={handleReset} onApply={() => apply(draft)} />
      </SidebarFooter>
    </>
  );
};
